import React from 'react';
import { DateTimeInput } from './index';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Grid, Typography } from '@ts/storybook';

interface DateTimeRangeProps extends WithTranslation {
  title: string;
  disabled?: boolean;
  onChangeDateFrom?: (date: string | Date | null) => void;
  onChangeDateTo?: (date: string | Date | null) => void;
  valueDateFrom?: string;
  valueDateTo?: string;
  timezone?: string;
}

const DateTimeRange: React.FC<DateTimeRangeProps> = ({
  title,
  disabled = false,
  onChangeDateFrom,
  onChangeDateTo,
  valueDateFrom,
  valueDateTo,
  timezone,
  t,
}) => {
  return (
    <Grid container>
      <Grid size={{ xs: 12 }}>
        <Typography variant="body1" component="h2" text={title} />
      </Grid>
      <Grid container justifyContent="flex-start" size={{ xs: 12 }}>
        <Grid size={{ xs: 12 }}>
          <DateTimeInput
            timezone={timezone}
            disabled={disabled}
            onChange={onChangeDateFrom}
            value={valueDateFrom}
            labelDate={`${t('From date (included)')}`}
            labelTime={`${t('From time (included)')}`}
          />
        </Grid>
      </Grid>
      <Grid container justifyContent="flex-start" size={{ xs: 12 }}>
        <Grid size={{ xs: 12 }}>
          <DateTimeInput
            timezone={timezone}
            disabled={disabled}
            onChange={onChangeDateTo}
            value={valueDateTo}
            labelDate={`${t('To date (included)')}`}
            labelTime={`${t('To time (included)')}`}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withTranslation()(DateTimeRange);
